import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const MockPayment = () => {
  const [searchParams] = useSearchParams();
  const amount = searchParams.get('amount') || '100';
  const orderId = searchParams.get('txnid') || 'TEST123';

  useEffect(() => {
    // Auto redirect after 3 seconds for demo
    const timer = setTimeout(() => {
      window.location.href = '/payment-success?status=success&txnid=' + orderId;
    }, 3000);

    return () => clearTimeout(timer);
  }, [orderId]);

  const handleSuccess = () => {
    window.location.href = '/payment-success?status=success&txnid=' + orderId;
  };

  const handleFailure = () => {
    window.location.href = '/payment-failed?status=failed&txnid=' + orderId;
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Mock Payment Gateway</h1>
          <p className="text-gray-600">Test Payment Interface</p>
        </div>

        <div className="bg-blue-50 p-4 rounded-lg mb-6">
          <h3 className="font-semibold text-blue-900 mb-2">Payment Details</h3>
          <p className="text-blue-800">Order ID: {orderId}</p>
          <p className="text-blue-800">Amount: ₹{amount}</p>
        </div>

        <div className="space-y-3">
          <button
            onClick={handleSuccess}
            className="w-full bg-green-600 hover:bg-green-700 text-white py-3 rounded-lg font-medium"
          >
            ✅ Simulate Success
          </button>
          
          <button
            onClick={handleFailure}
            className="w-full bg-red-600 hover:bg-red-700 text-white py-3 rounded-lg font-medium"
          >
            ❌ Simulate Failure
          </button>
        </div>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-500">
            Auto-redirecting to success in 3 seconds...
          </p>
        </div>
      </div>
    </div>
  );
};

export default MockPayment;